import {styled} from '../../utils';
import {Wrapper} from '../Layout';

export default styled(Wrapper)({
  borderRadius: 3,
  backgroundColor: '#fff',
  transition: 'all .3s'
});



// WEBPACK FOOTER //
// ./src/components/Card/Card.tsx